import { render, staticRenderFns } from "./AccountsList.vue?vue&type=template&id=4731246e&scoped=true&"
import script from "./AccountsList.vue?vue&type=script&lang=js&"
export * from "./AccountsList.vue?vue&type=script&lang=js&"
import style0 from "./AccountsList.vue?vue&type=style&index=0&id=4731246e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4731246e",
  null
  
)

export default component.exports